import React from 'react';
import styled, { css } from 'styled-components';
import { FaLeaf, FaEye, FaBullseye } from 'react-icons/fa';

const glass = css`
  backdrop-filter: blur(14px) saturate(180%);
  -webkit-backdrop-filter: blur(14px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.22);
  box-shadow: 0 14px 45px rgba(0, 0, 0, 0.16);
`;

const VmgSection = () => {
  return (
    <Wrap>
      <MissionVisionGoalsContainer>
        <SectionContainer>
          <IconContainer>
            <FaLeaf size={34} />
          </IconContainer>
          <h3>Mission</h3>
          <p>
            Our mission is to empower farmers and communities by leveraging artificial intelligence to achieve sustainable
            agricultural practices.
          </p>
        </SectionContainer>

        <SectionContainer>
          <IconContainer>
            <FaEye size={34} />
          </IconContainer>
          <h3>Vision</h3>
          <p>
            To create a sustainable and resilient agricultural ecosystem by integrating advanced AI technologies and
            empowering communities.
          </p>
        </SectionContainer>

        <SectionContainer>
          <IconContainer>
            <FaBullseye size={34} />
          </IconContainer>
          <h3>Goals</h3>
          <p>
            1. Promote Zero Hunger (Goal 2).
            <br />
            2. Foster Responsible Consumption (Goal 12).
            <br />
            3. Combat Climate Change (Goal 13).
          </p>
        </SectionContainer>
      </MissionVisionGoalsContainer>
    </Wrap>
  );
};

export default VmgSection;

const Wrap = styled.section`
  padding: 4rem 1.25rem;
  display: flex;
  justify-content: center;
  background: transparent;
`;

const MissionVisionGoalsContainer = styled.div`
  display: flex;
  gap: 1.25rem;
  width: min(1100px, 92vw);
  align-items: stretch;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const SectionContainer = styled.div`
  ${glass}
  flex: 1;
  border-radius: 18px;
  padding: 2rem 1.6rem;
  text-align: center;

  /* Green-tinted glass */
  background: linear-gradient(180deg, rgba(19, 111, 7, 0.20), rgba(255, 255, 255, 0.10));
  color: rgba(7, 4, 4, 0.95);

  transition: transform 0.22s ease, box-shadow 0.22s ease, background 0.22s ease;

  h3 {
    font-size: 1.65rem;
    font-weight: 800;
    margin: 0.75rem 0 0.75rem;
    font-family: 'Chau Philomene One', sans-serif;
    text-shadow: 0 10px 22px rgba(0, 0, 0, 0.28);
  }

  p {
    font-size: 1.05rem;
    line-height: 1.75;
    margin: 0;
    color: rgba(12, 9, 9, 0.92);
  }

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 18px 55px rgba(0, 0, 0, 0.22);
    background: linear-gradient(180deg, rgba(19, 111, 7, 0.26), rgba(255, 255, 255, 0.12));
  }
`;

const IconContainer = styled.div`
  ${glass}
  width: 56px;
  height: 56px;
  margin: 0 auto;
  border-radius: 16px;
  display: grid;
  place-items: center;
  background: rgba(255, 255, 255, 0.14);
  color: rgba(220, 255, 225, 0.95);
`;
